import { createContext, useContext, useEffect, useState } from "react";
import { I18N } from "@/data/site";

const LangCtx = createContext({ lang: "en", t: I18N.en, setLang: () => {} });

export function LangProvider({ children }) {
  const [lang, setLang] = useState(() => {
    try {
      return localStorage.getItem("fp_lang") || "en";
    } catch {
      return "en";
    }
  });

  useEffect(() => {
    try { localStorage.setItem("fp_lang", lang); } catch {}
    document.documentElement.lang = lang;
  }, [lang]);

  const t = I18N[lang] || I18N.en;
  return (
    <LangCtx.Provider value={{ lang, setLang, t }}>
      {children}
    </LangCtx.Provider>
  );
}

export function useLang() {
  return useContext(LangCtx);
}
